export class Cesionario {
   public cesionarioId: string;
   public rutFormateado: string;
   public rut: number;
   public dv: string;
   public razonSocial: string;
   public direccion: string;
   public correo: string;
   public fono: string;
   public emisorId: string;
   public activo: boolean;
   public nombreContacto: string;

   showActions?: boolean;
}
